module.exports = __webpack_public_path__ + "img/share-w.311ed16.svg";